import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { CroppedImage } from './CroppedImage';
import { BRAND, FINAL_SUBLINE, PURCHASE_MOCKUP, pricing } from '../data/resinContent';
export function FinalOfferSection() {
  return <section className="w-full border-t border-champagne/25 bg-black" aria-labelledby="final-title" data-id="element-144" data-mp="2nyw925urkvkt">
      <div className="mx-auto grid max-w-5xl items-center gap-8 px-5 py-12 sm:grid-cols-2 sm:gap-12 sm:py-16" data-id="element-145" data-mp="1qd89xd6xbz5l">
        <CroppedImage image={PURCHASE_MOCKUP} className="mx-auto w-full max-w-md sm:max-w-none" data-id="element-146" data-mp="1vbrxtj52vl0l" />

        <div className="text-center sm:text-left" data-id="element-147" data-mp="208s49v5uaps8">
          <CountdownTimer label="Launch offer ends in" className="mb-7 sm:text-left [&>div]:justify-center sm:[&>div]:justify-start" data-id="element-148" data-mp="250tdf87po0e1" />

          <h2 id="final-title" className="font-display text-[2rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.5rem]" data-id="element-149" data-mp="17jl5cv2h3y6g">
            {BRAND}
          </h2>
          <p className="mt-2 text-[12px] font-medium uppercase tracking-[0.14em] text-ivory-300" data-id="element-150" data-mp="2cjpgpyfm673p">{FINAL_SUBLINE}</p>

          <p className="mt-5 border-t border-charcoal-600 pt-5 text-[12px] uppercase tracking-[0.12em] text-muted" data-id="element-151" data-mp="22rs36l14v31t">
            Regular price <span className="line-through" data-id="element-152" data-mp="1xrxd2jp6mhht">{pricing.regularPrice}</span>
          </p>
          <p className="mt-1 font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-153" data-mp="1trwow7ca6rxk">
            <span className="mr-2 align-middle font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-champagne" data-id="element-154" data-mp="1os0r4pu6fwqg">
              Today
            </span>
            {pricing.today}
            <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-155" data-mp="1euw5cr48u3a6">
              USD
            </span>
          </p>

          <div className="mt-6 flex justify-center sm:justify-start" data-id="element-156" data-mp="39843arnimv01">
            <CtaButton target="checkout" size="md" data-id="element-157" data-mp="398wzwzsrg44g" />
          </div>
          <TrustStrip variant="full" className="mt-3 sm:justify-start" data-id="element-158" data-mp="17hwupq0louew" />
        </div>
      </div>
    </section>;
}